import { AsyncValidatorFn, ValidatorFn } from '@angular/forms';
import { RowMapperType } from 'app/b2b-order/services/order-product-detail/ui-mapper';
import { Dictionary } from 'types';

export interface Header {
    text: string;
    key: string;
}

export interface Cell {
    placeholder?: string;
    hasTooltip?: boolean;
    value: string | number;
    isMarked?: boolean;
    inputOptions?: CellInputOptions;
}

export interface CellInputOptions {
    validators?: ValidatorFn[];
    asyncValidators?: AsyncValidatorFn[];
    disabled?: boolean;
    blocked?: boolean;
    e2eHooks?: {
        input?: string;
        placeholder?: string;
    };
}

export interface Row {
    label?: string;
    zeroth?: Cell & { key?: string };
    cells: Dictionary<Cell>;
    type?: RowMapperType;
    key?: string;
}

export interface MatrixRowValue {
    rowIndex: number;
    row: Dictionary;
    hasChanges: boolean;
}

export interface UpdatedMatrixRow extends MatrixRowValue {
    matrixStatus: {
        isValid: boolean;
        isInvalid: boolean;
        isPending: boolean;
    };
    status: {
        isValid: boolean;
        isInvalid: boolean;
        isDisabled: boolean;
        isPending: boolean;
    };
    type: RowMapperType;
}

export enum PlaceholderVariant {
    Floating = 'floating',
    Fixed = 'fixed'
}

export enum MatrixStatus {
    Valid = 'VALID',
    Invalid = 'INVALID',
    Disabled = 'DISABLED',
    Pending = 'PENDING'
}

export enum OrderMatrixStatus {
    Valid = 'VALID',
    Invalid = 'INVALID'
}

export interface MatrixData {
    dataSource: Row[];
    headers: Header[];
}

export interface MatrixBlurEvent {
    previousDataSource: Row[];
    currentDataSource: Row[];
    hasChanges: boolean;
}
